import SomethingWentWrongScreenImage from '../../assets/images/SomethingWentWrongScreen.svg';
import ReloadIcon from '../../assets/images/ReloadIcon.svg';
const SomethingWentWrong = () => {
    const handleRefresh = () => {
        if (process.env.REACT_APP_INSTALLATION_MODE != 'desktop')
            window.location.reload();
    };
    return (
        <div>
            <div className=" flex items-center justify-center w-full h-full mt-[5%]">
                <div className=" flex items-center justify-center flex-col mt-[5rem]">
                    <img
                        src={SomethingWentWrongScreenImage}
                        alt="Error Getting Books"
                    />
                    <p className=" text-3xl font-bold text-black mt-2">
                        Something went wrong!
                    </p>
                    <p className="text-black font-light text-xl mt-2">
                        Please retry, if it’s not resolved, contact customer
                        support.
                    </p>
                    <div
                        className="mt-4 px-6 py-2 flex justify-center space-x-2  bg-blue-500 text-white rounded-xl hover:bg-blue-600 hover:cursor-pointer"
                        onClick={handleRefresh}
                    >
                        <img src={ReloadIcon} alt="Retry Icon" />
                        <p>Retry</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SomethingWentWrong;
